import { defineStore } from "pinia";
import _ from "lodash";
import { useHsaTotalStore } from "./hsaTotal";
import { useHsaStore } from "./hsa";

const TAX_SAVINGS_PERCENT = 25;

export const useTaxSavingsStore = defineStore("taxSavings", {
    state: () => ({}),
    getters: {
        isLoaded: () => (year: number) => {
            const hsaTotalStore = useHsaTotalStore();
            const hsaStore = useHsaStore();
            return hsaTotalStore.otherHsaAmountsLoaded && hsaStore.contributionTotalsLoaded(year);
        },
        taxSavings: () => (year: number) => {
            const hsaTotalStore = useHsaTotalStore();
            const hsaStore = useHsaStore();

            return (hsaTotalStore.otherHsaAmount(year)
                + hsaStore.employeePreTaxContributions(year)
                + hsaStore.actualEmployeePersonalContributions(year)
                + hsaStore.bankDirectContributions(year)) * (TAX_SAVINGS_PERCENT / 100);
        },
        taxSavingPercent: () => TAX_SAVINGS_PERCENT
    },
    actions: {
        load (args?: { username?: string, partnerId?: number, force?: boolean, year?: number } ) {
            const hsaTotalStore = useHsaTotalStore();
            const hsaStore = useHsaStore();

            hsaTotalStore.loadOtherHsaAmounts(args);
            hsaStore.loadTransactionTotals(args);
        }
    }
});